module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "feature-area section-padding2 toubugaodu",
    staticStyle: {
      "height": "400px",
      "background": "url('../static/assets/images/bannerc.jpg') no-repeat",
      "background-size": "100% auto"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "about_tab"
  }, [_c('router-link', {
    staticClass: "about_tab_jj",
    attrs: {
      "to": "/about"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("企业简介")]), _vm._v(" "), _c('router-link', {
    staticClass: "about_tab_wh",
    attrs: {
      "to": "/wenhua"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("企业文化")]), _vm._v(" "), _c('router-link', {
    staticClass: "about_tab_jg",
    attrs: {
      "to": "/jiagou"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("企业架构")]), _vm._v(" "), _c('router-link', {
    staticClass: "about_tab_zr",
    staticStyle: {
      "background": "#0473db",
      "color": "#ffffff"
    },
    attrs: {
      "to": "/zeren"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("认证体系")]), _vm._v(" "), _c('router-link', {
    staticClass: "about_tab_sm",
    attrs: {
      "to": "/shengming"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("版权声明")])], 1)]), _vm._v(" "), _c('section', {
    staticClass: "feature-area section-padding2 about_section1"
  }, [_c('div', {
    staticClass: "container zerentoplist",
    staticStyle: {
      "padding-top": "100px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.aboutinfo.content)
    }
  }), _vm._v(" "), _vm._l((_vm.stringToArray(_vm.aboutinfo.pics)), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "single-job mb-4 d-lg-flex justify-content-between",
      staticStyle: {
        "padding": "0px"
      }
    }, [_c('div', {
      staticClass: "job-text wow fadeInLeft animated zerenchongzu",
      staticStyle: {
        "padding": "40px 50px"
      }
    }, [_c('h4', {
      staticClass: "zerenziti",
      staticStyle: {
        "font-size": "18px",
        "font-weight": "500"
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.stringToArrayshu(_vm.stringToArray(_vm.aboutinfo.picstitle)[index])[0]))]), _vm._v(" "), _c('ul', {
      staticClass: "mt-4 zerenkuan"
    }, [_c('li', {
      staticClass: "mb-3 zerentiku",
      staticStyle: {
        "color": "#a89d99"
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.stringToArrayshu(_vm.stringToArray(_vm.aboutinfo.picstitle)[index])[1]) + "\n                    "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "jiayige1",
      staticStyle: {
        "color": "#000000",
        "line-height": "50px"
      }
    }, [_vm._v(_vm._s(_vm.stringToArrayshu(_vm.stringToArray(_vm.aboutinfo.picstitle)[index])[2]))])]), _vm._v(" "), _c('li', {
      staticClass: "buxianshi",
      staticStyle: {
        "margin-top": "80px",
        "width": "50px",
        "height": "50px",
        "line-height": "50px",
        "text-align": "center",
        "font-size": "18px",
        "background": "#dddddd",
        "color": "#a89d99"
      }
    }, [_vm._v("\n                    ▷ ")])])]), _vm._v(" "), _c('div', {
      staticClass: "job-img align-self-center wow zoomIn animated zerenimage"
    }, [_c('img', {
      attrs: {
        "src": _vm.newurl + item
      }
    })])])
  })], 2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row toubugaoduzt",
    staticStyle: {
      "height": "400px",
      "line-height": "400px",
      "color": "#ffffff",
      "font-size": "45px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('p', {
    staticStyle: {
      "font-style": "initial"
    }
  }, [_vm._v("关于我们")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0b0c380"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Zeren.vue
// module id = 115
// module chunks = 0